
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Dhamal Dandiya</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm dhamaal-dandiya-yearly section-banner-bg-1">
    <div class="container">
         <div class="sec-title text-center">
            <h2>Dhamal<span > Dandiya </span></h2>
        </div>
        <div class="row">
            <div class="col-md-4 ">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2023</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2023/dandiya2023.avif"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2023</h3>
                            <a href="dhamaal-dandiya-year2023">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4 ">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2019</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/15.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2019</h3>
                            <a href="dhamaal-dandiya-year2019">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2018</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/d1.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2018</h3>
                            <a href="dhamaal-dandiya-year2018">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2017</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/d2.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2017</h3>
                            <a href="dhamaal-dandiya-year2017">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2016</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/d4.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2016</h3>
                            <a href="dhamaal-dandiya-year2016">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <h4>Dhamaal Dandiya-2015</h4>
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/d5.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dhamaal Dandiya-2015</h3>
                            <a href="dhamaal-dandiya-year2015">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>

        </div>
    </div>
</section>
